import { AddLabelButton, LabelsPage } from "features/labels";
import useAllLabels from "features/labels/datahooks/useAllLabels";

import RenderIf from "common/components/RenderIf";
import { NavTabsContentContainer } from "common/layouts/WorkspaceLayout";

import { LEADS_TAB_ITEMS } from "../constants";

const labelType = "workspace";

export default function Labels() {
  const { allLabels } = useAllLabels(labelType);

  const primaryActionsComponent = (
    <RenderIf condition={!!allLabels?.length}>
      <AddLabelButton size="sm" labelType={labelType} />
    </RenderIf>
  );

  return (
    <NavTabsContentContainer
      primaryActionsComponent={primaryActionsComponent}
      tabItems={LEADS_TAB_ITEMS}
    >
      <LabelsPage type={labelType} />
    </NavTabsContentContainer>
  );
}
